module.exports = __webpack_public_path__ + "media/images/product_owners/pm_ivas_90-e9c9edb477a5c7541ae081a6292bb702.png";